// extracted by mini-css-extract-plugin
module.exports = {"TitleWrapper":"MoreComponent__TitleWrapper___1C-ER","ContactInfoWrapper":"MoreComponent__ContactInfoWrapper___HPXzw"};